import Guide from './'

export default Guide.extend({

  el: '<div class="size-arrow">' +
      '   <span class="end-caps"></span>' +
      '   <span class="baseline"></span>' +
      '</div>',

  offset: 2,

  minArrowLength: 18,

  render: function () {
    Guide.prototype.render.apply(this, arguments)

    if (this.type === 'vertical' && this.$el.height() < this.minArrowLength) {
      this.$el.addClass('arrowless')
    }

    if (this.type === 'horizontal' && this.$el.width() < this.minArrowLength) {
      this.$el.addClass('arrowless')
    }

    return this
  }

})
